<template>
  <div class="AggregateStatusPopoverSimple">
    <div :style="headerStyle">
      <div style="flex-grow: 1; display: flex; align-items: center; gap: 15px;">
        <h3>
          {{ popoverTitle }}
        </h3>
        <span v-if="store.showAdvanced" style="font-family: 'Reddit Mono'; padding-top: 1px;">
          {{ channelLabel }}
        </span>
        <AggregateStatusAuxiliariesOrder :tag="tag"></AggregateStatusAuxiliariesOrder>
      </div>
      <Button text severity="secondary" style="margin-right: -10px; color: gray; border: 0;" @click="emit('update:showingPopover', false)">
        <i class="pi pi-times"></i>
      </Button>
    </div>
    <TieredMenu class="AggregateStatusPopoverSimple" :model="menuItems" style="border: 0;"></TieredMenu>
  </div>
</template>

<script setup>
import store, { showingDesktopUi } from "./store.js";
import AggregateStatusAuxiliariesOrder from "./AggregateStatusAuxiliariesOrder.vue";
import { computed } from "vue";
import { controlChannelLabel, openHistory } from "./appUtility.js";

let props = defineProps([
  "tag",
  "popoverTitle",
  "controlTempAggrs",
  "showControlTempPriority"
]);

let emit = defineEmits([
  "calibrate"
]);

let headerStyle = computed(() => {
  return {
    padding: showingDesktopUi.value ? "15px" : "0",
    display: "flex",
    alignItems: "center",
    gap: "15px",
    marginBottom: showingDesktopUi.value ? "-5px" : "15px"
  };
});

let isAggrComputed = computed(() => {
  let sensors = props.tag.sensors.children;
  return (sensors.length == 0);
});

let channelLabel = computed(() => {
  let sensors = props.tag.sensors.children;
  return (sensors.length == 0) ? "(computed)" : controlChannelLabel(sensors[0]);
});

let menuItems = computed(() => [
    { 
      separator: true,
      visible: showingDesktopUi.value
    },
    { 
      label: "View history",
      command: () => openHistory(props.tag)
    },
    { 
      label: "Set priority",
      visible: props.showControlTempPriority,
      items: props.controlTempAggrs.map((aggr, index) => {
        return {
          label: `Priority ${index + 1}`,
          icon: (props.tag.controlTempPriority?.value == index) ? "pi pi-check" : "pi",
          command: () => setAggregatePriority(index)
        };
      })
    },
    { 
      label: "Calibrate",
      visible: store.showAdvanced && !isAggrComputed.value,
      disabled: props.tag.commError.value,
      command: () => emit("calibrate")
    }
]);

function setAggregatePriority(newPriority) {
  let tag1 = props.tag;
  let tag2 = props.controlTempAggrs[newPriority];
  props.tag.$session.changeSettings([
    { handle: tag1.controlTempPriority.handle, value: newPriority },
    { handle: tag2.controlTempPriority.handle, value: tag1.controlTempPriority.value }
  ]);
  emit("update:showingPopover", false);
}
</script>

<style>
.AggregateStatusPopoverSimple .p-menuitem-content {
  padding: 3px;
  font-size: large;
}
</style>